export const jiraStatuses = [
  { value: 'in progress', label: 'В работе' },
  { value: 'done', label: 'Выполнено' },
  { value: 'resolved', label: 'Решенные' },
  { value: 'closed', label: 'Закрытые' },
  { value: 'to do', label: 'Сделать' },
  { value: 'Тестирование', label: 'Тестирование' },
  { value: 'review', label: 'Review' },
  { value: 'blocked', label: 'Заблокирована' },
  { value: 'Stable Тестирование', label: 'Stable Тестирование' },
  { value: 'Stable Выполнено', label: 'Stable Выполнено' },
  { value: 'Prod Выполнено', label: 'Prod Выполнено' },
  { value: 'In Review', label: 'In Review' },
  { value: 'Backlog', label: 'Backlog' },
  { value: 'Selected for Development', label: 'Selected for Development' },
  { value: 'In testing dev Globus', label: 'In testing dev Globus' },
  { value: 'In testing Dev Bank', label: 'In testing Dev Bank' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Ready for test', label: 'Ready for test' },
  { value: 'Tested', label: 'Tested' },
  { value: 'Тестирование у заказчика', label: 'Тестирование у заказчика' },
  { value: 'В тестировании', label: 'В тестировании' },
  { value: 'Готово в DEV', label: 'Готово в DEV' },
  { value: 'Определения объема работ', label: 'Определения объема работ' },
  { value: 'Прототипы', label: 'Прототипы' },
  { value: 'Дизайн концепты', label: 'Дизайн концепты' },
  { value: 'Дизайн Ревью', label: 'Дизайн Ревью' },
  { value: 'Макет', label: 'Макет' },
  { value: 'Закрыт', label: 'Закрыт' },
  { value: 'Выбрано для разработки', label: 'Выбрано для разработки' },
  { value: 'Первая итерация', label: 'Первая итерация' },
  { value: 'Вторая итерация', label: 'Вторая итерация' },
  { value: 'Третья итерация', label: 'Третья итерация' },
  { value: 'Утверждено', label: 'Утверждено' },
  { value: 'Кодревью', label: 'Кодревью' },
  { value: 'На утверждении', label: 'На утверждении' },
  { value: 'На паузе', label: 'На паузе' },
  { value: 'Заблокировано', label: 'Заблокировано' },
  { value: 'Testing11', label: 'Testing11' },
  { value: 'Work in progress', label: 'Work in progress' },
  { value: 'На проверке', label: 'На проверке' },
  { value: 'Тестирование (dev)', label: 'Тестирование (dev)' },
  { value: 'Тестирование (stage)', label: 'Тестирование (stage)' },
  { value: 'Тестирование (prod)', label: 'Тестирование (prod)' },
  { value: 'Bugfix', label: 'Bugfix' },
  { value: 'Need to merge', label: 'Need to merge' },
  { value: 'На уточнении', label: 'На уточнении' },
  { value: 'Эпики', label: 'Эпики' },
  { value: 'На доработке', label: 'На доработке' },
  { value: 'На тесте', label: 'На тесте' },
  { value: 'Нужна аналитика', label: 'Нужна аналитика' },
  { value: 'Нужен дизайн', label: 'Нужен дизайн' },
  { value: 'Приоритет 2', label: 'Приоритет 2' },
  { value: 'Приоритет 3', label: 'Приоритет 3' },
  { value: 'Архив', label: 'Архив' },
  { value: 'Катим на тест', label: 'Катим на тест' },
  { value: 'тест', label: 'тест' },
  { value: 'Колонка 1', label: 'Колонка 1' },
  { value: 'Бэклог', label: 'Бэклог' },
  { value: 'Ожидание обратной связи', label: 'Ожидание обратной связи' },
  { value: 'Отложено', label: 'Отложено' },
  { value: 'Hold', label: 'Hold' },
  { value: 'Катим в прод', label: 'Катим в прод' },
];
